import { render, staticRenderFns } from "./SelectProductTable.vue?vue&type=template&id=4219cb31&"
import script from "./SelectProductTable.vue?vue&type=script&lang=js&"
export * from "./SelectProductTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports